import createIcon from '../../createIcon';

/**
 * @component @name EighteenUpRating
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC41IDE1SDEwVjlIN1YxMC41SDguNVYxNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOSAzSDVDMy45IDMgMyAzLjkgMyA1VjE5QzMgMjAuMSAzLjkgMjEgNSAyMUgxOUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlWNUMyMSAzLjkgMjAuMSAzIDE5IDNaTTE5IDE5SDVWNUgxOVYxOVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMi41IDE1SDE1QzE1LjU1IDE1IDE2IDE0LjU1IDE2IDE0VjEwQzE2IDkuNDUgMTUuNTUgOSAxNSA5SDEyLjVDMTEuOTUgOSAxMS41IDkuNDUgMTEuNSAxMFYxNEMxMS41IDE0LjU1IDExLjk1IDE1IDEyLjUgMTVaTTEzIDEwSDE0LjVWMTEuNUgxM1YxMFpNMTMgMTIuNUgxNC41VjE0SDEzVjEyLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EighteenUpRating = createIcon('EighteenUpRating', [
  ['path', { d: 'M8.5 15H10V9H7V10.5H8.5V15Z', key: 'a3x56g' }],
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z',
      key: 'i1bke7',
    },
  ],
  [
    'path',
    {
      d: 'M12.5 15H15C15.55 15 16 14.55 16 14V10C16 9.45 15.55 9 15 9H12.5C11.95 9 11.5 9.45 11.5 10V14C11.5 14.55 11.95 15 12.5 15ZM13 10H14.5V11.5H13V10ZM13 12.5H14.5V14H13V12.5Z',
      key: 'wg61v4',
    },
  ],
]);

export default EighteenUpRating;
